// extracted by mini-css-extract-plugin
export default {"root":"ConfirmModal_root__fq-d6","titleContainer":"ConfirmModal_titleContainer__aBaLF","buttons":"ConfirmModal_buttons__vyU5F"};